import Vue from 'vue'
import vueResource from 'vue-resource'
console.log(process.env);
Vue.use(vueResource);
export default{
    install:function (Vue) {
        function get(uri,obj,callback){
            var url=process.env.apiHost+uri+"?s="+encodeURIComponent(this.$getSession());
                //
            var n=arguments.length;
            if(n==3){
                var data={
                    params:obj
                };
            }else{
                var data={
                    params:{}
                }
            }


            showLoad();
            this.$http.get(url,data).then(function (result) {
                hideLoad();
                if(n==3){
                    callback&&callback(result.data);
                }else{
                    obj&&obj(result.data);
                }

            }).catch(function (reason) {
                console.log(reason);
                if (reason && (reason.body==='' || reason.body === undefined)) return;

                alert("出错了" + reason ? reason.body:'');
                hideLoad();
            });
        }

      function getPay(uri,obj,callback) {
        //TODO:
        var url=process.env.payHost+uri+"?s="+encodeURIComponent(this.$getSession());
        var n=arguments.length;
        if(n==3){
          var data={
            params:obj
          };
        }else{
          var data={
            params:{}
          }
        }


        showLoad();
        this.$http.get(url,data).then(function (result) {
          hideLoad();
          if(n==3){
            callback&&callback(result.data);
          }else{
            obj&&obj(result.data);
          }

        }).catch(function (reason) {
          console.log(reason);
          if (reason && (reason.body==='' || reason.body === undefined)) return;

          alert("出错了" + reason ? reason.body:'');
          hideLoad();
        });
      }


      function post(uri,obj,callback){
            var url=process.env.apiHost+uri+"?s="+encodeURIComponent(this.$getSession());
                // +encodeURIComponent(this.$getSession());
            var n=arguments.length;
            if(n==3){
                var data=obj;
            }else{
                var data={};
            }
            showLoad();
            this.$http.post(url,data,{emulateJSON: true}  ).then(function (result) {
                hideLoad();
                if(n==3){
                    callback&&callback(result.data);
                }else{
                    obj&&obj(result.data);
                }
            }).catch(function (reason) {
              console.log(reason);
              if (reason && (reason.body==='' || reason.body === undefined)) return;

                alert("出错了" + reason ? reason.body:'');
                hideLoad();
            })
        }

      function postPay(uri,obj,callback) {
        //var existUrl = process.env.payHost+uri+"?s="+encodeURIComponent(this.$getSession());
        var url=process.env.payHost+uri+"?s="+encodeURIComponent(this.$getSession());
        // +encodeURIComponent(this.$getSession());
        var n=arguments.length;
        if(n==3){
          var data=obj;
        }else{
          var data={};
        }
        showLoad();
        this.$http.post(url,data,{emulateJSON: true}  ).then(function (result) {
          hideLoad();
          if(n==3){
            callback&&callback(result.data);
          }else{
            obj&&obj(result.data);
          }
        }).catch(function (reason) {
          console.log(reason);
          if (reason && (reason.body==='' || reason.body === undefined)) return;

          alert("出错了" + reason ? reason.body:'');
          hideLoad();
        })
      }

        function showLoad(){
            document.querySelector("#loading").style.display="block";
        }
        function hideLoad(){
            document.querySelector("#loading").style.display="none";
        }
        function getSession(){
          var ss = window.sessionStorage.getItem("session");
          if (!ss || ss==='undefined' || ss==='null') {
            ss = window.localStorage.getItem("session");
          }
          return ss;
        }
        function setSession(data){
            window.sessionStorage.setItem("session",data);
        }
        function getCity(){
            // return window.sessionStorage.getItem("city")||310100
            return 310100
        }
        function getProfileStoreId(){
            return window.sessionStorage.getItem("ProfileStoreId")||''
        }
        Vue.prototype.$get=get;
        Vue.prototype.$getPay=getPay;
        Vue.prototype.$post=post;
        Vue.prototype.$postPay=postPay;
        Vue.prototype.$showLoad=showLoad;
        Vue.prototype.$hideLoad=hideLoad;
        Vue.prototype.$getSession=getSession;
        Vue.prototype.$setSession=setSession;
        Vue.prototype.$getCity=getCity;
        Vue.prototype.$getProfileStoreId=getProfileStoreId;
    }
}



// WEBPACK FOOTER //
// ./src/shared/service/service.js